import { createAuthStore } from "@/stores/createAuthStore";
import {
  adminLoginApi,
  adminRefreshApi,
  adminLogoutApi,
  type AdminProfile,
  type AdminAuthResponse,
} from "@/portals/admin/api/adminAuthApi";

// The backend's /login and /refresh responses carry no admin profile at all (verified
// against the live API) — `user` stays null until something populates it (e.g. a
// follow-up GET /admin/me). AdminSidebar/AdminDashboardPage already render fine with a
// null user, but this means the admin's name/email never actually appear today.
function toSession(data: AdminAuthResponse) {
  return { accessToken: data.access_token, expiresIn: data.expires_in_minutes, user: null };
}

// AdminProfile is nullable — see the toSession comment: the backend never actually
// returns an admin profile from login/refresh.
export const useAdminAuthStore = createAuthStore<AdminProfile | null, [email: string, password: string]>({
  portal: "admin",

  signIn: async (email, password) => {
    const { data, error } = await adminLoginApi(email, password);
    if (!data) return { data: null, error };
    return { data: toSession(data), error: null };
  },

  refresh: async () => {
    const { data, error } = await adminRefreshApi();
    if (!data) return { data: null, error };
    return { data: toSession(data), error: null };
  },

  signOut: () => adminLogoutApi().then(() => {}),
});
